(function () {
    'use strict';

    angular.module("imApp").factory("consignmentScanService", ['$ihttp', function ($ihttp) {
        let service = {
            scanConsignment: function (setting) {
                return $ihttp.post({
                    method: 321,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
